// extracted by mini-css-extract-plugin
module.exports = {"mainColor":"#1b9b9b","whyUs":"#316767"};